import { setNonce } from 'get-nonce'

/** react-remove-scroll / react-style-singleton's supported CSP integration. */
export function configureStyleNonce() {
  const nonce = document.querySelector('meta[property="csp-nonce"]')?.getAttribute('content')
  if (nonce && /^[A-Za-z0-9+/]{32}$/.test(nonce)) setNonce(nonce)
}
